import { render, staticRenderFns } from "./DistributionUserPage.vue?vue&type=template&id=3379861c&scoped=true"
import script from "./DistributionUserPage.vue?vue&type=script&lang=js"
export * from "./DistributionUserPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionUserPage.vue?vue&type=style&index=0&id=3379861c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3379861c",
  null
  
)

export default component.exports